module.exports = __webpack_public_path__ + "static/media/amiibo.c9476b93.png";